/** @format */

/**
 * Hook for API data management
 * Users, AORs, and NPNs are now fetched by their respective components
 * using GraphQL queries with office ID filtering
 */
export const useApiData = () => {
  return { 
    loading: false, 
    error: null 
  };
};
